import { AsyncAiUpsellInEditorFreeModal } from './ui/async';

export default AsyncAiUpsellInEditorFreeModal;
